import type { ClientId } from '../../core/ClientId';
import type { EventCategory } from '../../core/Core';
import type { InternalUserSchedule } from '../../Scenario';
import { EntryState } from '../../Scenario';

interface EventIdBag {
  createdEventIds: Set<ClientId>;
  deletedEventIds: Set<ClientId>;
  updatedEventIds: Set<ClientId>;
}

export enum OldEntryState {
  CREATED = 'C',
  UPDATED = 'U',
}

export function migrateScenarioDeleteEventIds(
  scenario: InternalUserSchedule,
): InternalUserSchedule {
  const scenarioWithMaybeExtraField: InternalUserSchedule & {
    eventIds?: {
      [EventCategory.TC]: EventIdBag;
      [EventCategory.Single]: EventIdBag;
      [EventCategory.OffHire]: EventIdBag;
      [EventCategory.COA]: EventIdBag;
      [EventCategory.Spot]: EventIdBag;
      [EventCategory.PortCall]: EventIdBag;
    };
  } = { ...scenario };

  if (
    'eventIds' in scenarioWithMaybeExtraField &&
    scenarioWithMaybeExtraField.eventIds
  ) {
    const entryStates: Map<ClientId, OldEntryState | EntryState> =
      scenarioWithMaybeExtraField.entryStates;

    // Transfer data from deprecated eventIds to entryStates where entry doesn't already have an entryState flag
    for (const eventIds of Object.values(
      scenarioWithMaybeExtraField.eventIds,
    )) {
      for (const clientId of [...eventIds.createdEventIds]) {
        if (!entryStates.has(clientId)) {
          entryStates.set(clientId, EntryState.UPDATED);
        }
      }
      for (const clientId of [...eventIds.updatedEventIds]) {
        if (!entryStates.has(clientId)) {
          entryStates.set(clientId, EntryState.UPDATED);
        }
      }
      for (const clientId of [...eventIds.deletedEventIds]) {
        if (!entryStates.has(clientId)) {
          entryStates.set(clientId, EntryState.DELETED);
        }
      }
    }
    delete scenarioWithMaybeExtraField.eventIds;

    // CREATED is no longer a valid value (was redundant, clean them)
    for (const [clientId, state] of [...entryStates]) {
      if (state === OldEntryState.CREATED) {
        entryStates.set(clientId, EntryState.UPDATED);
      }
    }
  }
  return scenarioWithMaybeExtraField;
}
